<template>
<div :class="show_sku || show_poster ? 'page_shopdetail page_iteminfo page_limit': 'page_shopdetail page_iteminfo' ">
    <div class="goods_logo">
        <van-swipe class="my-swipe detail_swipe" :autoplay="bannerTime">
            <van-swipe-item :show-indicators="false" :loop="false" v-for="(item,index) in goodsDetail.good_album" :key="index">
                <img :src="imageUrl+item" alt="" />
            </van-swipe-item>
        </van-swipe>
        <!-- <img :src="this.publicPath + 'statics/images/temp/good.png'" alt="" /> -->
    </div>
    <div class="goods_top">
        <div class="title">
            <span>{{ goodsDetail.good_title }}</span>
            <span class="icon_self" v-if="goodsDetail.is_self">自营</span>
            <span class="icon_new" v-if="goodsDetail.is_new">最新</span>
        </div>
        <div class="goods_info">
            <span class="price"><span class="tag_cash">￥</span>{{ goodsDetail.good_price }}</span>
            <span class="stock">数量<span class="num">{{ goodsDetail.good_store }}</span>{{ goodsDetail.good_unit }}</span>
            <span class="stock"> {{ goodsDetail.good_place }}</span>
        </div>
        <div class="actions">
            <!-- <div class="action store">收藏</div> -->
            <div :class="goodsDetail.is_collect == 1 ? 'action stored': 'action unstore'" @click="collectionClick">
                {{ goodsDetail.is_collect == 1 ? "已收藏" : "收藏" }}
            </div>
            <div class="action share" @click="shareGoods">分享</div>
        </div>
        <div class="goods_tags clearfix">
            <div class="f-l tag" v-if="goodsDetail.is_seven_return==1">七天无理由退换货</div>
            <div class="f-l tag tag_red" v-if="goodsDetail.is_chargecard==1">年礼卡可使用-孝亲卡</div>
        </div>
    </div>
	<!-- 区块链 追溯码 -->
	<div class="trace" v-if="goodsDetail.is_blockchain" @click="toGoodTracecode">
		<div class="trace_t">区块链溯源</div>
		<!-- <div class="trace_b" @click="toGoodTracecode">{{ goodsDetail.blockchain_key }}</div> -->
	</div>
    <!-- 评价 -->
    <div class="comment" v-if="goodcomment.count != 0">
        <div class="title">
            <span class="">作品评价</span>
            <span class="comment_num" v-if="goodcomment">{{"(" + goodcomment.count + ")"}}</span>
            <span class="looktotal" v-if="goodcomment.count > 1 " @click="toComment">查看全部&gt;</span>
        </div>
        <!-- <div class="comment_none" v-if="goodcomment.count == 0">本商品暂无评论信息</div> -->
        <div class="con margin_no_left">
            <div class="con_top clearfix">
                <div class="f-l thumb" v-if="goodcomment&&goodcomment.count>0">
                    <img :src="goodcomment.thumb ? ($publicData.withHttpStart(goodcomment.thumb) ? goodcomment.thumb: imageUrl+goodcomment.thumb) : $publicData.defaultTouxiang" alt="" />
                </div>
                <div class="f-l con_top_r" v-if="goodcomment.name">
                    <span class="user_name">{{ $publicData.formatPhone(goodcomment.name) }}</span>
                    <span class="time">{{goodcomment.created_at}}</span>
                </div>
            </div>
            <div class="con_nr" v-if="goodcomment.content">
                <div class="yiji_txt">
                    {{ goodcomment.content }}
                </div>
            </div>
        </div>
    </div>
    <!-- 作品详情 -->
    <div class="xiangqing">
        <div class="nr">
            <div class="title">作品详情</div>
            <!-- 属性 -->
            <div class="table">
                <div class="tr clearfix" v-for="(guige,index) in goodsDetail.good_attr" :key="index" v-if="guige.good_attr_value&&guige.good_attr_value!='null'&&guige.good_attr_value!='undefined'&&guige.good_attr_value!=''">
                    <div class="f-l">{{ guige.good_attr_name }}</div>
                    <div class="f-r">{{ guige.good_attr_value }}</div>
                </div>
            </div>
            <!-- 内容介绍 -->
            <p v-html="goodsDetail.good_content" class="jieshao"></p>
        </div>
    </div>
    <!-- 店信息 -->
    <div class="shop_info">
        <div class="info_t" :style="goodsDetail.is_platprice == 1 ? 'padding-bottom: 0;': 'padding-bottom: 0.55rem;'">
            <div class="info_t_l" @click="toTradesman('a')" v-if="goodsDetail.is_platprice != 1">
                <img v-if="goodsDetail.tradesman" :src="goodsDetail.tradesman.thumb ? ($publicData.withHttpStart(goodsDetail.tradesman.thumb) ? goodsDetail.tradesman.thumb : imageUrl+goodsDetail.tradesman.thumb) : $publicData.defaultTouxiang" alt="" class="logo" />
                <span class="name" v-if="goodsDetail.tradesman">{{goodsDetail.tradesman.name}}</span>
            </div>
            <div class="info_t_l" @click="toSeller" v-if="goodsDetail.is_platprice == 1">
                <img v-if="goodsDetail.tradesman" :src="goodsDetail.tradesman.thumb ? ($publicData.withHttpStart(goodsDetail.tradesman.thumb) ? goodsDetail.tradesman.thumb : imageUrl+goodsDetail.tradesman.thumb) : $publicData.defaultTouxiang" alt="" class="logo" />
                <span class="name" v-if="goodsDetail.tradesman">{{goodsDetail.tradesman.name}}</span>
            </div>
            <div v-if="goodsDetail.is_platprice != 1" :class="goodsDetail.is_attention == 1 ?'info_t-r guanzhu': 'info_t-r'" @click="attentionTradesMan(goodsDetail.tradesman)">
                {{ goodsDetail.is_attention == 1 ? "已关注" : "关注" }}
            </div>
            <!-- 供应商 展示不同 -->
            <div class="item" @click="toSeller" v-if="goodsDetail.is_platprice == 1">
                <div class="name">商品/作品</div>
                <div class="num" v-if="goodsDetail.tradesman" style="text-align:center;">
                    {{ goodsDetail.tradesman.count_good }}
                </div>
            </div>
        </div>
        <div class="info_b" v-if="goodsDetail.is_platprice != 1">
            <div class="item" @click="toTradesman('a')">
                <div class="name">商品/作品</div>
                <div class="num" v-if="goodsDetail.tradesman">
                    {{ goodsDetail.tradesman.count_good }}
                </div>
            </div>
            <div class="item">
                <div class="line"></div>
            </div>
            <div class="item" @click="toFans">
                <div class="name">粉丝</div>
                <div class="num" v-if="goodsDetail.tradesman">
                    {{ goodsDetail.tradesman.count_user }}
                </div>
            </div>
            <div class="item">
                <div class="line"></div>
            </div>
            <div class="item" @click="toTradesman('b')">
                <div class="name">约·看</div>
                <div class="num" v-if="goodsDetail.tradesman">
                    {{ goodsDetail.tradesman.count_live }}
                </div>
            </div>
        </div>
    </div>
    <!-- 推荐产品 -->
    <div class="goods">
        <div class="title">推荐产品</div>
        <div class="datalist">
            <ul class="list">
                <li class="item" v-for="goods in goodsDetail.other_good" :key="goods.good_id" @click="goShopDetail(goods)">
                    <div :class="goods.is_blockchain ? 'thumb blockchain' : 'thumb' ">
                        <van-image class="vanImage" fit="contain" :show-error="false" :show-loading="false" :src="goods.thumb ? imageUrl+goods.thumb : $publicData.intangibleDefault" />
                    </div>
                    <div class="item_xinxi">
                        <div class="title_wrap single">
                            <div class="title_tag">
                                <span class="icon_self" v-if="goods.is_self">自营</span>
                                <span class="icon_new" v-if="goods.is_new">最新</span>
                            </div>
                            <span v-if="goods.is_self && goods.is_new" class="title title1 slh_s"> {{ goods.good_title }}</span>
                            <span v-else-if="goods.is_self || goods.is_new" class="title title2 slh_s"> {{ goods.good_title }}</span>
                            <span v-else class="title title3 slh_s"> {{ goods.good_title }}</span>
                        </div>
                        <div class="info clearfix">
                            <div class="shop_name f-l slh_s">{{ goods.tradesman_name?goods.tradesman_name :'' }}</div>
                            <div class="source f-r">{{ goods.place }}</div>
                        </div>
                        <div class="info">
                            <span class="f-l price">¥{{ goods.good_price }}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <!-- 底部 购买 -->
    <div class="bottom clearfix" v-if="goodsDetail.is_made!=1">
        <div class="bottom_l f-l">
            <div class="item" @click="toServe">
                <img :src="this.publicPath + 'statics/images/icon_kefu.png'" alt="" class="item_icon" />
                <span class="txt">客服</span>
            </div>
            <div class="item">
                <div class="line"></div>
            </div>
            <!-- 匠人 -->
            <div class="item" @click="toTradesman('a')" v-if="goodsDetail.is_platprice != 1">
                <img :src="this.publicPath + 'statics/images/icon_dian.png'" alt="" class="item_icon" />
                <span class="txt">店铺</span>
            </div>
            <!-- 供应商 -->
            <div class="item" @click="toSeller" v-if="goodsDetail.is_platprice == 1">
                <img :src="this.publicPath + 'statics/images/icon_dian.png'" alt="" class="item_icon" />
                <span class="txt">店铺</span>
            </div>
            <div class="item">
                <div class="line"></div>
            </div>
            <div class="item" @click="toCart">
                <img :src="this.publicPath + 'statics/images/icon_cart.png'" alt="" class="item_icon" />
                <span class="txt">购物车</span>
            </div>
        </div>
        <div class="bottom_r f-l">
            <div class="action shopcar" @click="onShowSku(0)">加入购物车</div>
            <div class="action buynow" @click="onShowSku(1)">立即购买</div>
        </div>
    </div>
    <div class="bottom clearfix" v-else>
		<!-- toServe toMadeServe-->
        <div class="action shopcar big_btn" @click="toServe">联系商家</div>
    </div>
    <!-- 规格弹窗 -->
    <div class="sku_wrap" v-if="show_sku">
        <div class="sku">
            <div class="sku_t">
                <div class="sku_t_l" @click="showGoodsImage">
                    <img :src="selectPrice.thumb?imageUrl+selectPrice.thumb:(goodsDetail.good_thumb ?imageUrl+goodsDetail.good_thumb: $publicData.intangibleDefault) " alt="" class="tu" />
                </div>
                <div class="sku_t_r">
                    <div class="price">
                        <span class="tag_cash">{{selectPrice.good_price?'￥':''}}</span>{{ selectPrice.good_price?selectPrice.good_price:'缺货' }}
                    </div>
                    <div class="sku_title">库存：{{ selectPrice.good_store?selectPrice.good_store:0 }}{{ goodsDetail.good_unit }}</div>
                    <div class="sku_title slh">{{ goodsDetail.good_title }}</div>
                </div>
            </div>
            <div class="sku_nr" v-for="spec in goodsSpec" :key="spec.id">
                <div class="sku_nr_name">{{ spec.name }}</div>
                <div class="sku_items">
                    <div v-for="item in spec.goodspecitem" :key="item.id" @click="clickGoodsSpec(spec, item)">
                        <div class="sku_item active" v-if="item.isSelect">
                            {{ item.item }}
                        </div>
                        <div class="sku_item " v-else>{{ item.item }}</div>
                    </div>
                </div>
            </div>
            <div class="sku_nums clearfix">
                <div class="sku_nums_l f-l">数量</div>
                <div class="adjustSku f-r">
                    <van-stepper v-model="selectNum" />
                </div>
            </div>
        </div>
        <!-- 按钮区 -->
        <div class="sku_actions">
            <div class="sku_action" @click="onAddCartClicked">{{tag_buy ? '立即购买':'确定' }}</div>
        </div>
    </div>
    <van-image-preview v-model="showSkuImage" :images="skuImages" >
    </van-image-preview>
    <!-- 全局的弹层 遮罩-->
    <van-overlay :show="show_sku" @click="show_sku=false;bannerTime='3000'" class="sku_overlay" />
	<!-- 分享的图片,类似海报 -->
	<van-overlay :show="show_poster" @click="show_poster = false" class="" />
	<!-- <div class="share_poster" v-if="show_poster">
		<div class="title">{{goodsDetail.good_title}}</div>
		<div class="shop">{{ goodsDetail.tradesman.name }}</div>
		<div class="thumb">
			<van-image class="vanImage" fit="contain" :show-error="false" :show-loading="false" :src="goodsDetail.good_thumb? goodsDetail.good_thumb : $publicData.intangibleDefault" />
		</div>
		<div class="price">{{'￥'+ goodsDetail.good_price }}</div>
		<div class="desc slh">{{ goodsDetail.good_describe }}</div>
		<div class="wechat">
			<img :src="publicPath+'statics/temp/qrcode.png'" alt="" class="code_tu">
		</div>
	</div>
	<div class="share_tips" v-if="show_poster">长按保存图片</div> -->
	<div class="poster" v-if="show_poster">
		<img :src="imageUrl + posterUrl" alt="" class="posterTu">
	</div>
	<div class="share_tips" v-if="show_poster">长按保存图片</div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN,
    SETTLE
} from "../../../.././vuex/mutation_types";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
import { Toast } from 'vant';
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    // name: "map-index",
    data() {
        return {
			richImageUrl: this.$publicData.richTextImage,
			imageUrl: this.$publicData.uploadImage,
            bannerTime: '3000',
            goodsId: this.$route.query.goodsId,
            publicPath: process.env.BASE_URL,
            show_sku: false, // 规格弹层
            tag_buy: false, // 购买标识
            tag_addCart: false, // 加购标识
            goodsDetail: {},
            goodsSpec: [],
            goods: {
                picture: "https://img.yzcdn.cn/1.jpg", // 默认商品 sku 缩略图
            },
            selectSpec: "",
            selectPrice: {},
            selectNum: 1,
            token: null,
            goodcomment: {}, // 评论
			shareConfig: null, // 分享的相关配置
			show_poster: false, // 海报弹层
			posterUrl: null, // 分享图链接
            showSkuImage: false, // 规格图片
            skuImages: []
        };
    },
    components: {
        // PageSearch
    },
    watch: {
        '$route.query': function (n, o) {
            // console.log('n',n,'o',o)
            if (n) {
                this.goodsId = n.goodsId;
                this.getGoodsDetailData();
            }
        }
    },
    created: function () {
        // this.$store.commit(LOGIN, {
        //     token: 'PcXDUJmXARBSUuN9KBl74Q==',
        // });
        // 根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    naviBlackStyle: true,
                    naviTitle: "商品详情",
                    levitate: true
                },
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    }
					this.getGoodsDetailData();
					
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback("");
                }
            );
        } else {
            this.token = this.$store.getters.token;
        }

		// console.log(this.$refs.marker)
		// 获取分享图片
		this.getSharePoster()
    },
    mounted() {
        window.scrollTo(0, 0);
        this.goodsId = this.$route.query.goodsId
        this.getGoodsDetailData();
        // document.body
        console.log("mounted");
        window.addEventListener("scroll", this.onScroll);
    },
    destroyed() {
        console.log("destroyed");
        window.removeEventListener("scroll", this.onScroll);
    },
    methods: {
        shareGoods() {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var that = this
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: that.goodsDetail.good_title ? that.goodsDetail.good_title : that.$publicData.shareDefaultTitleA,
                        detail: that.goodsDetail.good_describe ? that.goodsDetail.good_describe : '',
                        url: url,
                        platFormType:'',
                        image: that.goodsDetail.good_thumb ? that.$publicData.domain + that.goodsDetail.good_thumb : that.$publicData.domain + that.$publicData.shareDefaultIcon
                    },
                };
                this.$bridge.callhandler("sdjy://public/share", params, (data) => {});
            } else {
                this.show_poster = true
            }
        },
        // 获取商品详情
        getGoodsDetailData() {
			let that = this;
            var params = {
                token: this.token,
                good_id: this.goodsId,
            };
            this.$api.shop.goodsDetail(params).then((res) => {
                if (res.code == 200) {
					// 如果该商品已下架
					if(res.result.good_status == 0){
						this.$toast('该商品已下架')
						// B2B商品
						if(res.result.is_platprice == 1){
							setTimeout(function(){
								that.$router.push({
									path: '/shop/btob'
								})
							},1000)
							
						}else{
							// b2c商品
							setTimeout(function(){
								that.$router.push({
									path: '/shop/index'
								})
							},1000)
							
						}
						return;
					}
					// 如果该商品在售
                    this.goodsDetail = res.result;
					// 匹配富文本
					let good_content = res.result.good_content;
					let content = good_content.replace(/(<img [^>]*src=['"])([^'"]+)([^>]*)/g, function (match, $1,$2,$3){
						if(/^http/.test($2)){
							return $1 +$2 + $3;
						}else{
							return $1 + that.richImageUrl +$2 + $3;
						}
					});
					this.goodsDetail.good_content = content;
                    this.goodcomment = res.result.goodcomment;
                    this.skuImages = [this.goodsDetail.good_thumb]
                    this.getGoodsSpec();
                    // 调起 获取微信分享参数函数
                    this.getShareData()
                    var goodsAttr = res.result.good_attr
                    console.log(goodsAttr)
                    if (goodsAttr && goodsAttr != undefined) {
                        for (let j = 0; j < goodsAttr.length; j++) {
                            let g = goodsAttr[j];
                            if (
                                g.good_attr_value != null &&
                                g.good_attr_value != "null"
                            ) {
                                let a = g.good_attr_value; //eval('(' +g.good_attr_value + ')');
                                // console.log("a1", a);
                                a = this.unicode2Ch(a);
                                // console.log("a2", a);
                                var b = a
                                b = a.replace(/\"/g, "")
                                // console.log('b', b)
                                g.good_attr_value = b
                            }
                        }
                    }
                    // console.log('goodsAttr',goodsAttr)
                } else {
                    this.$toast(res.message);
                }
            });
        },
        //获取商品规格
        getGoodsSpec() {
            var params = {
                token: this.token,
                good_id: this.goodsId,
            };
            this.$api.shop.goodsSpec(params).then((res) => {
                if (res.code == 200) {
                    this.goodsSpec = res.result;
                    var specKey = "_";
                    var specId = "";
                    for (let i = 0; i < this.goodsSpec.length; i++) {
                        const spec = this.goodsSpec[i];
                        for (let j = 0; j < spec.goodspecitem.length; j++) {
                            const item = spec.goodspecitem[j];
                            if (j == 0) {
                                item.isSelect = true;
                                specId = item.id;
                                specKey += item.id;
                                specKey += "_";
                            } else {
                                item.isSelect = false;
                            }
                        }
                    }
                    if (specKey == "_") {
                        specKey = "";
                    }
                    this.selectSpec = specKey;
                    if (specKey && specKey != undefined && specKey != '') {
                        this.getSpecPrice(specKey,false);
                    } else {
                        this.selectPrice = {
                            good_price: this.goodsDetail.good_price,
                            good_store: this.goodsDetail.good_store,
                        };
                    }

                } else {
                    this.$toast(res.message);
                }
            });
        },
        //获取规格价格
        getSpecPrice(spec_key,show) {
            var params = {
                token: this.token,
                good_id: this.goodsId,
                spec_key: spec_key,
            };
            this.$api.shop.goodsSpecPrice(params).then((res) => {
                if (res.code == 200) {
                    if (res.result != null) {
                        this.selectPrice = res.result;
                        if (show) {
                            if (this.selectPrice.good_store <= 0) {
                                this.$toast('库存不足，请选择其它规格')
                            }
                        }
                        
                    } else {
                        this.selectPrice = {
                            good_price: this.goodsDetail.good_price,
                            good_store: this.goodsDetail.good_store,
                        };
                    }
                } else {
                    this.$toast(res.message);
                }
            });
        },
        showGoodsImage() {
            this.skuImages = [this.selectPrice.thumb?this.selectPrice.thumb:(this.goodsDetail.good_thumb ?this.goodsDetail.good_thumb: this.$publicData.intangibleDefault)]
            this.showSkuImage = true
        },
        //选择规格
        clickGoodsSpec(selectGoodsSpec, selectItem) {
            var specKey = "_";
            var list = this.goodsSpec;
            for (let i = 0; i < list.length; i++) {
                var spec = list[i];
                for (let j = 0; j < spec.goodspecitem.length; j++) {
                    var item = spec.goodspecitem[j];
                    if (selectGoodsSpec.id == spec.id) {
                        if (item.id == selectItem.id) {
                            item.isSelect = true;
                            specKey += item.id;
                            specKey += "_";
                        } else {
                            item.isSelect = false;
                        }
                        spec.goodspecitem[j] = item;
                    } else {
                        if (item.isSelect) {
                            specKey += item.id;
                            specKey += "_";
                        }
                    }
                }
                list[i] = spec;
            }
            this.goodsSpec = list;
            if (specKey == "_") {
                specKey = "";
            }
            this.selectSpec = specKey;
            // console.log('this.selectSpec',this.selectSpec)
            this.getSpecPrice(specKey,true);
        },
        // 推荐商品跳转详情
        goShopDetail(goods) {
            console.log('goods', goods)
            var p = "?goodsId=" + goods.good_id;
            var url = this.$publicData.clientUrl + "/shop/detail" + p
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    data: {
                        url: url
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                // location.href = url;
                this.$router.push("/shop/detail" + p);
                $(window).scrollTop(0);
                // this.goodsId = goods.good_id;
                // this.getGoodsDetailData();
                // this.getGoodsSpec();
            }
        },
        // 直接购买 -- 不用了
        onBuyClicked(e) {
            console.log("onBuyClicked");
            console.log(e);
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/shop/settle"
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.$router.push({
                    path: "/shop/settle",
                });
            }
        },
        // 加入购物车
        onAddCartClicked() {
			var that = this;
            // this.tag_buy = true
            //     this.tag_addCart = false
            if (this.selectPrice.good_price == null) {
                this.$toast('该规格暂时缺货')
                return
            }
            if (this.tag_buy) {
                //直接购买
                console.log("buy");
                if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                    //获取用户信息
                    var memberParams = {
                        data: {},
                    };
                    this.$bridge.callhandler(
                        "sdjy://member/memberInfo",
                        memberParams,
                        (data) => {
                            if (data.code == 200) {
                                this.token = data.result.token;
                                this.goodsBuy();
                            }
                        }
                    );
                } else if (userAgent.indexOf('MicroMessenger') != -1) {// 在微信中
                    console.log('MicroMessenger')
                    wx.miniProgram.getEnv(function(res) {
                        if (res.miniprogram) {
                            // 走在小程序的逻辑
                            Toast('请在公众号中搜索“时代记忆”进行购买')
                        } else {
                            if (!that.$store.getters.token) {
                                localStorage.setItem('redirect', that.$router.currentRoute.fullPath)
                                that.$router.push({
                                    path: '/login',
                                })
                                return
                            }
                            that.goodsBuy();
                        }
                    })
                    return
                } else {
                    if (!this.$store.getters.token) {
                        localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                            this.$router.push({
                                path: '/login',
                            })
                            return
                        }
                    this.goodsBuy();
                }
            } else {
                //加入购物车
                if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                    //获取用户信息
                    var memberParams = {
                        data: {},
                    };
                    this.$bridge.callhandler(
                        "sdjy://member/memberInfo",
                        memberParams,
                        (data) => {
                            if (data.code == 200) {
                                this.token = data.result.token;
                                this.addToCart();
                            }
                        }
                    );
                } else {
                    //TODO 未登录判断
                    this.addToCart();
                }
            }
        },
        goodsBuy() {
            var that = this
            var params = {
                token: this.token,
                good_id: this.goodsId,
                good_spec_key: this.selectSpec,
                num: this.selectNum,
            };
            console.log(params);
            this.$parent.showLoading()
            this.$api.shop.goodsSettle(params).then((res) => {
                that.$parent.hiddenLoading()
                that.$store.commit('REMOVEADDRESS');
                if (res.code == 200) {
					var data = res.result;
					console.log('data----------',data)
                    data.buy = 1;
                    that.$store.commit(SETTLE, {
                        shop_settle: JSON.stringify(data),
                    });
                    if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                        var params = {
                            data: {
                                key: "settle",
                                value: JSON.stringify(data)
                            },
                        };
                        // that.$bridge.callhandler(
                        //     "sdjy://public/saveInfo",
                        //     params,
                        //     (data) => {
                                //跳转至结算
                                var params = {
                                    data: {
                                        url: this.$publicData.clientUrl + "/shop/settle" + '?discount=' + res.result.discount
                                    },
                                };
                                this.$bridge.callhandler(
                                    "sdjy://public/openNewWebView",
                                    params,
                                    (data) => {}
                                );
                            // }
                        // );
                    } else {
                        
                        this.$router.push({
							path: "/shop/settle",
							query: {
								discount: res.result.discount
							}
                        });
                    }
                    this.$toast(res.message);
                } else {
                    this.$toast(res.message);
                }
            });
        },
        addToCart() {
            var params = {
                token: this.token,
                good_id: this.goodsId,
                type: 0,
                good_spec_key: this.selectSpec,
                num: this.selectNum,
            };
            // if ( this.selectSpec && this.selectSpec != undefined && this.selectSpec != '') {
            //     params.good_spec_key = this.selectSpec
            // }
            this.$parent.showLoading()
            this.$api.shop.shopCart(params).then((res) => {
                this.$parent.hiddenLoading()
                if (res.code == 200) {
                    this.show_sku = false;
                    this.bannerTime = '3000'
                    this.$toast(res.message);
                } else {
                    this.$toast(res.message);
                }
            });
        },
        collectionClick() {
            //收藏、取消收藏
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                //获取用户信息
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler(
                    "sdjy://member/memberInfo",
                    memberParams,
                    (data) => {
                        if (data.code == 200) {
                            this.token = data.result.token;
                            this.collectionGoods();
                        }
                    }
                );
            } else {
               
                this.collectionGoods();
            }
        },
        collectionGoods() {
            var type = 0;
            if (this.goodsDetail.is_collect == 1) {
                type = 1;
            }
            var params = {
                token: this.token,
                good_id: this.goodsId,
                type: type,
            };
            console.log(params);
            this.$api.shop.goodsCollection(params).then((res) => {
                if (res.code == 200) {
                    var goodsDetail = this.goodsDetail;
                    if (this.goodsDetail.is_collect == 1) {
                        goodsDetail.is_collect = 0;
                        this.$toast("取消收藏成功");
                    } else {
                        goodsDetail.is_collect = 1;
                        this.$toast("收藏成功");
                    }
                    this.goodsDetail = goodsDetail;
                } else {
                    this.$toast(res.message);
                }
            });
        },
        //关注匠人
        attentionTradesMan(tradesman) {
            if (this.goodsDetail.is_attention == 1) {
                return;
            }
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                //获取用户信息
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler(
                    "sdjy://member/memberInfo",
                    memberParams,
                    (data) => {
                        if (data.code == 200) {
                            this.token = data.result.token;
                            this.attention(tradesman);
                        }
                    }
                );
            } else {
                //TODO 未登录判断
                this.attention(tradesman);
            }
        },
        attention(tradesman) {
            var params = {
                token: this.token,
                tradesman_id: tradesman.id,
                type: 1
            }
            console.log(params)
            this.$api.tradesman.attention(params).then(res => {
                if (res.code == 200) {
                    this.goodsDetail.is_attention = 1;
                    this.$toast("关注匠人成功");
                } else {
                    this.$toast(res.message);
                }
            })
        },
        toFans() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/fans/index?tradesmanId='+ this.goodsDetail.tradesman.id + '&tradesman_uuid='+this.goodsDetail.tradesman.uuid
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/fans/index',
                    query: {
						tradesmanId: this.goodsDetail.tradesman.id,
						tradesman_uuid: this.goodsDetail.tradesman.uuid
                    }
                })
            }
        },
        toMadeServe() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/system/develop'
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/system/develop',
                    query: {
                        tradesmanId: this.goodsDetail.tradesman.id
                    }
                })
            }
        }, //定制联系客服
        toServe() {
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo",memberParams,(data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                        var uuid = this.goodsDetail.tradesman.uuid
                        console.log('uuid:',this.goodsDetail.from_uuid)
                        if (uuid == null || uuid == undefined || uuid == '') {
                            uuid = this.goodsDetail.from_uuid
                        }
                        var params = {
                            token: this.token,
                            uuid: uuid
                        };
                        that.$api.xiaoxi.userInfo(params).then(res => {
                            if (res.code == 200) {
                                var tradesmanInfo = res.result;
                                // console.log('创建了与匠人的通信')
                                // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);
                                console.log('toAppServe:',tradesmanInfo)
                                that.toAppServe(tradesmanInfo);
                            }
                        })
                    }
                });  
            } else {
                this.$router.push({
                    path: '/tradesman/chat',
                    query: {
                        uuid: this.goodsDetail.tradesman.uuid
                    }
                })
            }
        },
        toAppServe(tradesmanInfo) {
            console.log('toAppServe:',tradesmanInfo)
            var params = {
                data: {
                    
                },
            }
            if (this.goodsDetail.is_platprice == 1) {
                params = {
                    data: {
                        toId: tradesmanInfo.im_username,
                        conversationId: tradesmanInfo.im_username,
                        toAvator: tradesmanInfo.seller.company_photo,
                        toName: tradesmanInfo.seller.nickname,
                        toUUID: tradesmanInfo.seller.seller_uuid,
                        trandsmanId: tradesmanInfo.seller.id,
                        toPhone: tradesmanInfo.seller.phone, 
                        shopUrl: this.$publicData.clientUrl+'/seller/detail?sellerId='+tradesmanInfo.seller.id
                    },
                }
            } else {
                params = {
                    data: {
                        toId: tradesmanInfo.im_username,
                        conversationId: tradesmanInfo.im_username,
                        toAvator: this.goodsDetail.tradesman.thumb,
                        toName: this.goodsDetail.tradesman.name,
                        toUUID: this.goodsDetail.tradesman.uuid,
                        toPhone: tradesmanInfo.tradesmans.data.phone,
                        trandsmanId: this.goodsDetail.tradesman.id
                    },
                }
            }
            console.log('params:',params)
            this.$bridge.callhandler("sdjy://public/chat",params,(data) => {

            });
        },
        toTradesman(type) {
            if (type == null || type == undefined || type == '') {
                type = 'a'
            }
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + this.goodsDetail.tradesman.id + '&type=' + type
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/detail',
                    query: {
                        tradesmanId: this.goodsDetail.tradesman.id,
                        type: type
                    }
                })
            }
        },
        // 供应商 店铺
        toSeller() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/seller/detail?sellerId=' + this.goodsDetail.tradesman.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/seller/detail',
                    query: {
                        sellerId: this.goodsDetail.tradesman.id
                    }
                })
            }
        },
        //跳转购物车
        toCart() {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                //获取用户信息
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler(
                    "sdjy://member/memberInfo",
                    memberParams,
                    (data) => {
                        if (data.code == 200) {
                            var params = {
                                data: {
                                    url: this.$publicData.clientUrl + "/shop/cart"
                                },
                            };
                            this.$bridge.callhandler(
                                "sdjy://public/openNewWebView",
                                params,
                                (data) => {}
                            );
                        }
                    }
                );
            } else {
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath
                        // }
                    })
                    return
                }
                this.$router.push({
                    path: "/shop/cart",
                });
            }
        },
        toComment() {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/shop/comment"
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                var image = "";
                if (
                    this.goodsDetail.good_album &&
                    this.goodsDetail.good_album.length > 0
                ) {
                    image = this.goodsDetail.good_album[0];
                }
                this.$router.push({
                    path: "/shop/comment",
                    query: {
                        // title: this.goodsDetail.good_title,
                        // image: image,
                        // describe: this.goodsDetail.good_describe,
                        goodsId: this.goodsDetail.good_id,
                    },
                });
            }
        },
        // 开启 规格弹层
        onShowSku(status) {
            this.show_sku = true;
            this.bannerTime = '-'
            if (status) {
                this.tag_buy = true;
                this.tag_addCart = false;
            } else {
                this.tag_addCart = true;
                this.tag_buy = false;
            }
        },
        onScroll() {
            var scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            if (scrollTop <= 0) {
                if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                    var params = {
                        data: {
                            naviBlackStyle: true,
                            naviTitle: "",
                            levitate: true
                        },
                    };
                    this.$bridge.callhandler(
                        "sdjy://navigation/style",
                        params,
                        (data) => {}
                    );
                }
            } else {
                if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                    var alpha = scrollTop / 96.0;
                    if (alpha > 1) {
                        alpha = 1;
                    }
                    var params = {
                        data: {
                            naviBlackStyle: false,
                            naviTitle: "商品详情",
                            levitate: true,
                            alpha: alpha,
                        },
                    };
                    this.$bridge.callhandler(
                        "sdjy://navigation/style",
                        params,
                        (data) => {}
                    );
                }
            }
        },
        // 字符转码
        unicode2Ch(str) {
            if (!str) {
                return;
            }
            // 控制循环跃迁
            var len = 1;
            var result = "";
            // 注意，这里循环变量的变化是i=i+len 了
            for (var i = 0; i < str.length; i = i + len) {
                len = 1;
                var temp = str.charAt(i);
                if (temp == "\\") {
                    // 找到形如 \u 的字符序列
                    if (str.charAt(i + 1) == "u") {
                        // 提取从i+2开始(包括)的 四个字符
                        var unicode = str.substr(i + 2, 4);
                        // 以16进制为基数解析unicode字符串，得到一个10进制的数字
                        result += String.fromCharCode(parseInt(unicode, 16).toString(10));
                        // 提取这个unicode经过了5个字符， 去掉这5次循环
                        len = 6;
                    } else {
                        result += temp;
                    }
                } else {
                    result += temp;
                }
            }
            return result;
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.goodsDetail.good_title ? that.goodsDetail.good_title : that.$publicData.shareDefaultTitleA, // 分享标题
                    desc: that.goodsDetail.good_describe ? that.goodsDetail.good_describe : '', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.goodsDetail.good_thumb ? that.imageUrl + that.goodsDetail.good_thumb : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
		},
		// 获取分享图片 ** 后台返回的
		getSharePoster(){
			var that = this
			var params = {
				id: that.goodsId,
				type: 1 // 1商品 2匠人 3直播 4约看
			}
			that.$api.common.shareImg(params).then(res=>{
				if(res.code == 200){
					that.posterUrl = res.result
				}else{
					that.$toast(res.message)
				}
			})
		},
		// 区块链追溯码
		toGoodTracecode(){
			var that = this
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?goodsId=" + this.goodsDetail.good_id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/chain/scancodedetail" + p
                    }, 
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.$router.push({
                    path: "/chain/scancodedetail",
                    query: {
                        goodsId: this.goodsDetail.good_id,
                    },
                });
            }
		}
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.detail_wrap .project_info {
    text-align: left;
    padding: 0.4rem 0;
}

.page_shopdetail .jieshao {
    padding-left: 0;
    padding-right: 0;
}
/deep/.jieshao section{
	display: block !important;
}
</style>
